import { Injectable, inject } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { from, Observable } from "rxjs";
import { ProduktionsmallarComponent } from "../produktionsmallar.component";

@Injectable({
    providedIn: "root"
})
export class MinaProduktionsmallarDialogService {
    private readonly ngbModalService = inject(NgbModal);

    minaProduktionsmallarModal(): Observable<any> {
        if (!this.ngbModalService.hasOpenModals()) {
            const modalRef = this.ngbModalService.open(ProduktionsmallarComponent, {
                keyboard: false,
                backdrop: "static",
                size: "lg"
            });
            modalRef.componentInstance.isModalActive = true;
            return from(modalRef.result);
        }

        return from(null);
    }
}
